import { Autocomplete, TextField } from '@mui/material';
import type { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { AssetState } from '@/api/generatedApi';

const STATUS_OPTIONS = [
  { value: AssetState.Indexing, label: 'Indexing' },
  { value: AssetState.Finished, label: 'Finished' },
  { value: AssetState.Failed, label: 'Failed' },
  { value: AssetState.Unsupported, label: 'Unsupported' },
  { value: AssetState.No3DData, label: 'No 3D Data' },
];

interface StatusOption {
  value: AssetState;
  label: string;
}

export const StatusFilterInput = ({ item, applyValue }: GridFilterInputValueProps) => {
  const selectedValues: StatusOption[] = Array.isArray(item.value)
    ? STATUS_OPTIONS.filter(opt => item.value.includes(opt.value))
    : [];

  const handleChange = (_event: React.SyntheticEvent, newValue: StatusOption[]) => {
    const values = newValue.map(opt => opt.value);
    applyValue({ ...item, value: values.length > 0 ? values : undefined });
  };

  return (
    <Autocomplete
      multiple
      size='small'
      disableClearable
      options={STATUS_OPTIONS}
      value={selectedValues}
      onChange={handleChange}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      slotProps={{
        chip: {
          size: 'small' as const,
        },
      }}
      renderInput={parameters => (
        <TextField
          {...parameters}
          variant='outlined'
          label='Status'
          placeholder={selectedValues.length === 0 ? 'Select status...' : ''}
        />
      )}
      sx={{ minWidth: 200 }}
    />
  );
};
